import { logError } from "helpers/rxjs-operators/logError";
import { enRoles } from "interfaces/models/core/user/user";
import { FC, Fragment, PropsWithChildren, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { tap } from "rxjs";
import authService from "services/auth";
import Toast from "./Toast";
import { errorMessageFormatter } from "formatters/errorMessage";
import PermissionHide from "./PermissionHide";

type ICustomProps = {
  role?: enRoles | enRoles[];
};

type IProps = ICustomProps & PropsWithChildren;

const PermissionRoute: FC<IProps> = ({ role, children, ...props }) => {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [authParams, setAuthParams] = useState<any>({});

  useEffect(() => {
    const search = location.search.split("?");
    if (search.length > 1) {
      const params = search
        .pop()
        ?.split("&")
        .map((param) => param.split("="))
        .reduce(
          (arr, curr) => ({
            ...arr,
            [curr[0]]: curr[1],
          }),
          {},
        );
      setAuthParams(params || {});
    }
  }, [location.search]);

  useEffect(() => {
    const subscription = authService
      .isAuthenticated()
      .pipe(
        logError(),
        tap((isAuthenticated) => {
          if (!isAuthenticated) {
            authService.openLogin();
          }
        }),
      )
      .subscribe(setIsAuthenticated);

    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    if (!isAuthenticated && authParams && authParams.u && authParams.h) {
      authService
        .login(authParams.u, authParams.h)
        .pipe(logError(true))
        .subscribe(
          () => {},
          (error: any) => {
            Toast.error(errorMessageFormatter(error));
          },
        );
    }
  }, [isAuthenticated, authParams]);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <Fragment>
      <PermissionHide role={role}>{children}</PermissionHide>
    </Fragment>
  );
};

export default PermissionRoute;
